module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-300italic.c076c4892bc7a4be7b9097e97a35012d.woff2";